import { log } from '@hotjar/insights-common/lib/log';

/**
 * Twitter related tracking.
 */

let intervalId: number | undefined;

/**
 * Defers the tracking until we have the Twitter methods available.
 */
function deferredTracking(callback: () => void) {
  if (!intervalId) {
    intervalId = window.setInterval(() => {
      if (window.twttr && window.twttr.conversion) {
        clearInterval(intervalId);
        intervalId = undefined;
        callback();
      }
    }, 500);
  }
}

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `twitter` namespace.
 * Track that a user signed up.
 */
export const trackSignup = (): void => {
  if (window.twttr && window.twttr.conversion) {
    const isLive = document.location.host === 'insights.hotjar.com';

    log.debug('Twitter: Tracking sign-up');

    window.twttr.conversion.trackPid(isLive ? 'ntx05' : 'ntyg8', {
      tw_sale_amount: 0,
      tw_order_quantity: 0,
    });
  } else {
    deferredTracking(trackSignup);
  }
};
